import { render } from "./GiftManageDialog.vue?vue&type=template&id=2a137abc&scoped=true"
import script from "./GiftManageDialog.vue?vue&type=script&lang=js"
export * from "./GiftManageDialog.vue?vue&type=script&lang=js"

import "./GiftManageDialog.vue?vue&type=style&index=0&id=2a137abc&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a137abc"]])

export default __exports__